/*  ==========================================================================
    EHOTELIER PRICES
    Helpers to calculate prices, needs "bn_js_ratecalc"!
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import bnUtils from 'bn.utils';
import 'lodash/lodash.js';
import moment from 'moment';

// local imports
import * as ehotelierConfig from '../../globals/config/ehotelier/ehotelier-config';
import * as vars from '../../globals/variables';
import * as utils from "../utils";

/*
 * OFFER MIN PRICE
 */

export function initEhotelierOfferMinPrice (data) {
    let defaultpersons,
        guestcount,
        minPrice,
        pricesCol;
    data.records.forEach(function (record) {
        record.offerhotels.forEach(function (offerhotel) {
            minPrice = 0;
            if (offerhotel.minamount > 0) {

                // if offer has a minamount, use it
                minPrice = offerhotel.minamount;

            } else {
                pricesCol = [];

                // if offer has no minamount, search lowest and matching room price
                offerhotel.roomprices.forEach(function (roomprice) {
                    roomprice.roompriceguests.forEach(function (roompriceguest) {
                        defaultpersons = roomprice.roomtype[0].defaultpersons,
                            guestcount = roompriceguest.guestcount;

                        // if guestcount of the roomprice has the same value as the defaultpersons of the room, divide amount by defaultpersons
                        if (guestcount == defaultpersons) {
                            pricesCol.push(roompriceguest.amount / defaultpersons);
                        }

                    });
                });
                if (pricesCol.length) {
                    minPrice = Math.min.apply(Math, pricesCol);
                }
            }
            offerhotel.minprice = minPrice;
        });
    });
}

/*
 * OFFER ROOM PRICES
 */

export function initEhotelierOfferRoomPrices (data) {
    let defaultpersons,
        guestcount,
        offerRoomPrice;
    data.records.forEach(function(record) {
        record.offerhotels.forEach(function(offerhotel) {
            offerhotel.roomprices.forEach(function(roomprice) {
                roomprice.roompriceguests.forEach(function(roompriceguest) {
                    defaultpersons = roomprice.roomtype[0].defaultpersons,
                        guestcount = roompriceguest.guestcount;
                    if (guestcount == defaultpersons) {
                        offerRoomPrice = roompriceguest.amount / defaultpersons;
                    }
                });
                roomprice.offerroomprice = offerRoomPrice;
            });
        });
    });
}

/*
 * ROOM MIN PRICE
 */

export function initEhotelierRoomMinPrice (data) {

    // all seasons
    let all_seasons = data.records[0].seasons;

    // get all prices in order
    $.each(data.records[0].roomtypes, function(key,room_element) {
        if($(room_element.roomprices).length) {
            let roompricesOriginal = room_element.roomprices;
            let default_persons = room_element.defaultpersons;
            let sorted_roomprices = {};

            // group by boards
            let roompricesGroupedByBoard = roompricesOriginal.reduce(function (element_board, current_roomprice) {
                let board_key = current_roomprice.board.code;
                if (!element_board[board_key]) {
                    element_board[board_key] = {};
                }
                if (!element_board[board_key].data) {
                    element_board[board_key].data = [];
                }
                element_board[board_key].data.push(current_roomprice);
                return element_board;
            }, {});

            // group by min and max stay
            for (let board_item in roompricesGroupedByBoard) {
                let roompricesGroupedByMinMaxStay = roompricesGroupedByBoard[board_item].data.reduce(function (element_stay, current_roomprice) {
                    let stay_key = current_roomprice.minstay + '_' + current_roomprice.maxstay;
                    if (!element_stay[stay_key]) {
                        element_stay[stay_key] = [];
                    }
                    element_stay[stay_key].push(current_roomprice);
                    return element_stay;
                }, {});

                // group by season
                for (let item_season in roompricesGroupedByMinMaxStay) {
                    let roompricesGroupedBySeason = roompricesGroupedByMinMaxStay[item_season].reduce(function (element_season, current_roomprice) {
                        current_roomprice.seasondatas.forEach(function (seasons_item) {
                            let season_key = seasons_item.season.name;
                            if (!element_season[season_key]) {
                                element_season[season_key] = {};
                                let amount = 0;
                                current_roomprice.roompriceguests.forEach(function (roompriceguest_item) {
                                    if (roompriceguest_item.guestcount == default_persons) {
                                        amount = roompriceguest_item.amount / default_persons;
                                    }
                                });
                                element_season[season_key].final_amount = amount;
                            }
                        });
                        return element_season;
                    }, {});
                    let sorted_roompricesGroupedBySeason = [];
                    all_seasons.forEach(function (seasons_item) {
                        let season_name = seasons_item.name;
                        if (roompricesGroupedBySeason[season_name]) {
                            sorted_roompricesGroupedBySeason.push(roompricesGroupedBySeason[season_name]);
                        } else {
                            sorted_roompricesGroupedBySeason.push({
                                final_amount: 0
                            });
                        }
                    });
                    roompricesGroupedByMinMaxStay[item_season] = sorted_roompricesGroupedBySeason;
                }

                sorted_roomprices[board_item] = roompricesGroupedByMinMaxStay;
            }

            room_element.grouped_Prices = sorted_roomprices;
        }
    });

    // calculate room min price and add it to record
    let rooms = data.records[0].roomtypes;
    $.each( rooms, function( key, room_element ) {
        if($(room_element.grouped_Prices).length) {
            let grouped_Prices = room_element.grouped_Prices;
            let all_prices = [];

            // load all prices to array
            for (let code_board in grouped_Prices) {
                let stay_arr = grouped_Prices[code_board];
                for (let code_stay in stay_arr) {
                    $.each(stay_arr[code_stay], function (i, price_element) {
                        all_prices.push(price_element.final_amount);
                    });
                }
            }

            // remove 0
            let index = all_prices.indexOf(0);
            if (index != -1) {
                all_prices.splice(index, 1);
            }
            let minprice = Math.min.apply(Math, all_prices);
            room_element.minprice = minprice;

        }
    });
}

/*
 * ROOM PRICE LIST
 */

// price list calculation (needs "bn_js_ratecalc"!)
export function initEhotelierRoomPriceList (priceListContainer) {
    let $loader = $(priceListContainer).find('.bn-loader'),
        $noResult = $(priceListContainer).find('.bn-no-result');

    // check if prices are not loaded yet
    if(!$(priceListContainer).hasClass('eh-service--ready')) {

        // check if price type exist
        if ($(priceListContainer).attr('data-price-type')) {
            let priceType = $(priceListContainer).attr('data-price-type');

            // check if asa code exist
            if ($(priceListContainer).attr('data-asa-code')) {
                let asaCode = $(priceListContainer).attr('data-asa-code');

                // check if board code exist
                if ($(priceListContainer).attr('data-board-code')) {
                    let boardCode = $(priceListContainer).attr('data-board-code'),
                        debug = false,
                        todate = new moment().add(12, 'months').format('YYYY-MM-DD');

                    // activate debug mode if user is logged in typo3
                    if (vars.$body.hasClass('be-user')) {
                        debug = true;
                    }

                    // for testing purposes, todate gets set far in the future (only when "001_BRANDNAMIC_1" id is given, because the brandnamic hotel has the test prices set far in the future!)
                    if (vars.eh_hid === '001_BRANDNAMIC_1') {
                        todate = new moment().add(120, 'months').format('YYYY-MM-DD');
                    }

                    // create price listprice
                    let createPriceList = {};
                    createPriceList.functions = {
                        ratesReady: function (data) {
                            let structuredData = {};

                            // check if data exists
                            if (data === false) {

                                // show no result info and remove loader
                                $loader.remove();
                                $noResult.removeClass('hidden');

                            } else {

                                // get data
                                structuredData.pricelist = data;

                                // get ts constants (so you can use it in you hbs template)
                                structuredData.trans = vars.ts;

                                // remove loader and no result info
                                $loader.remove();
                                $noResult.remove();

                                // append object to container
                                priceListContainer.append(ehotelierConfig.priceLists.options[priceType].template(structuredData));

                                // add "ready" class to container
                                priceListContainer.addClass('eh-service--ready');

                                // callback
                                if(ehotelierConfig.priceLists.options[priceType].callback && typeof ehotelierConfig.priceLists.options[priceType].callback === 'function') {
                                    ehotelierConfig.priceLists.options[priceType].callback(priceListContainer);
                                }

                                // structured data info
                                if (vars.$body.hasClass('be-user')) {
                                    console.log('');
                                    console.log('----------------------------------------------------------------------------------------------------');
                                    console.log('PRICE STRUCTURE FOR "' + asaCode + '":');
                                    console.log(structuredData);
                                    console.log('----------------------------------------------------------------------------------------------------');
                                    console.log('');
                                }

                            }

                        }
                    };

                    // rates config
                    let ratesConfig = {
                        board: null,
                        debug: debug,
                        hotelid: vars.eh_hid,
                        lang: vars.lang,
                        portalid: vars.eh_pid,
                        rateplanorder: ['BN_1_3_' + boardCode, 'BN_4_6_' + boardCode, 'BN_7_null_' + boardCode],
                        rdyfunction: 'functions.ratesReady',
                        todate: todate
                    };
                    ratesConfig = $.extend({}, ratesConfig, ehotelierConfig.priceLists.options[priceType].config(boardCode));

                    // worker
                    let worker = bnUtils.createWorker('/typo3conf/ext/bn_typo_dist/Resources/Public/admin/js/helper/rates.js', createPriceList);
                    worker.api('ratecalc.presets.setConfig', ratesConfig);
                    worker.api('ratecalc.presets.' + ehotelierConfig.priceLists.options[priceType].preset, {
                        room: asaCode,
                        callback: 'functions.ratesReady'
                    });

                } else {

                    // warning message
                    if (vars.$body.hasClass('be-user')) {
                        console.log('');
                        console.log('----------------------------------------------------------------------------------------------------');
                        console.log('WARNING FOR RATE CALC:');
                        console.log('Board code is missing!');
                        console.log('Check if price container has a valid "data-board-code" attribute!');
                        console.log('----------------------------------------------------------------------------------------------------');
                        console.log('');
                    }

                }

            } else {

                // warning message
                if (vars.$body.hasClass('be-user')) {
                    console.log('');
                    console.log('----------------------------------------------------------------------------------------------------');
                    console.log('WARNING FOR RATE CALC:');
                    console.log('ASA code is missing!');
                    console.log('Check if price container has a valid "data-asa-code" attribute!');
                    console.log('----------------------------------------------------------------------------------------------------');
                    console.log('');
                }

            }

        } else {

            // warning message
            if (vars.$body.hasClass('be-user')) {
                console.log('');
                console.log('----------------------------------------------------------------------------------------------------');
                console.log('WARNING FOR RATE CALC:');
                console.log('Price type is missing!');
                console.log('Check if price container has a valid "data-price-type" attribute!');
                console.log('----------------------------------------------------------------------------------------------------');
                console.log('');
            }

        }

    } else {

        // warning message
        if (vars.$body.hasClass('be-user')) {
            console.log('');
            console.log('----------------------------------------------------------------------------------------------------');
            console.log('WARNING FOR RATE CALC:');
            console.log('Rates are already loaded!');
            console.log('----------------------------------------------------------------------------------------------------');
            console.log('');
        }

    }

}


// WEBPACK FOOTER //
// ./source/js/utilities/lib/ehotelier-prices.js